export default "__VITE_ASSET__dS_0YT3L__"